import { createAsyncThunk } from '@reduxjs/toolkit';

import { filesActions, filesSelector } from './filesSlice';

export const fetchFiles = createAsyncThunk('files/fetchFiles', async (_, thunkApi) => {
    const getFilesUrl = routable.getRoute('getFiles');

    try {
        const getFilesResponse = await fetch(`${getFilesUrl}`, {
            method: 'GET',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
        });

        if (!getFilesResponse.ok) {
            const error = await getFilesResponse.json();
            loader.hide();
            swal({
                text: error.message,
                cancel: false,
                confirm: true,
                button: {
                    text: i18next.t('filesSlice.action.fetchFiles.swal.button'),
                    value: true,
                    visible: true,
                    className: 'btn btn-secondary',
                },
            }).then(() => {
                window.location.reload();
            });
            return thunkApi.rejectWithValue(error.message);
        }

        const { data, is_last_page } = await getFilesResponse.json();

        if (!is_last_page) {
            await thunkApi.dispatch(filesActions.changeNeedMore(!is_last_page));
        }

        if (!data) {
            throw new Error();
        }

        return data;
    } catch (e) {
        return thunkApi.rejectWithValue(error.message ? error.message : error.toString());
    }
});
export const deleteFile = createAsyncThunk('files/deleteFiles', async (id, thunkApi) => {
    const deleteFileUrl = helpable.replaceUrlParameters(routable.getRoute('deleteFile'), {
        _attachmentId_: id,
    });
    try {
        const deleteFileResponse = await fetch(deleteFileUrl, {
            method: 'DELETE',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
        });

        if (!deleteFileResponse.ok) {
            const error = await deleteFileResponse.json();
            loader.hide();
            swal({
                text: error.message,
                cancel: false,
                confirm: true,
                button: {
                    text: i18next.t('filesSlice.action.fetchFiles.swal.button'),
                    value: true,
                    visible: true,
                    className: 'btn btn-secondary',
                },
            }).then(() => {
                window.location.reload();
            });
            return thunkApi.rejectWithValue(error.message);
        }

        return id;
    } catch (e) {
        return thunkApi.rejectWithValue(error.message ? error.message : error.toString());
    }
});
export const renameFile = createAsyncThunk(
    'files/renameFile',
    async ({ id, formData, name, extension }, thunkApi) => {
        const renameFileUrl = helpable.replaceUrlParameters(routable.getRoute('renameFile'), {
            _attachmentId_: id,
        });
        try {
            const renameFileResponse = await fetch(renameFileUrl, {
                method: 'POST',
                body: formData,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
            });

            if (!renameFileResponse.ok) {
                const error = await renameFileResponse.json();
                loader.hide();
                swal({
                    text: error.message,
                    cancel: false,
                    confirm: true,
                    button: {
                        text: i18next.t('filesSlice.action.fetchFiles.swal.button'),
                        value: true,
                        visible: true,
                        className: 'btn btn-secondary',
                    },
                }).then(() => {
                    window.location.reload();
                });
                return thunkApi.rejectWithValue(error.message);
            }
            const state = await thunkApi.getState();

            const file = filesSelector.selectById(state, id);

            const updatedFile = { ...file, name: `${name}.${extension}` };

            return { id, changes: updatedFile };
        } catch (e) {
            return thunkApi.rejectWithValue(error.message ? error.message : error.toString());
        }
    }
);

export const uploadFile = createAsyncThunk('files/uploadFile', async (formData, thunkApi) => {
    const addFilesUrl = routable.getRoute('addFiles');
    try {
        const addFilesResponse = await fetch(addFilesUrl, {
            method: 'POST',
            body: formData,
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
        });

        if (!addFilesResponse.ok) {
            const error = await addFilesResponse.json();
            loader.hide();
            swal({
                text: error.message,
                cancel: false,
                confirm: true,
                button: {
                    text: i18next.t('filesSlice.action.fetchFiles.swal.button'),
                    value: true,
                    visible: true,
                    className: 'btn btn-secondary',
                },
            });
            return thunkApi.rejectWithValue(error.message);
        }

        const { data } = await addFilesResponse.json();

        return data;
    } catch (e) {
        return thunkApi.rejectWithValue(error.message ? error.message : error.toString());
    }
});
export const loadMoreFiles = createAsyncThunk('files/loadMoreFiles', async (_, thunkApi) => {
    const getFilesUrl = routable.getRoute('getFiles');

    const state = thunkApi.getState();

    const ids = await state.filesReducer.ids;

    const lastId = ids.slice(-1)[0];

    try {
        const loadMoreResponse = await fetch(`${getFilesUrl}?last_id=${lastId}`, {
            method: 'GET',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
        });

        if (!loadMoreResponse.ok) {
            const error = await loadMoreResponse.json();
            loader.hide();
            swal({
                text: error.message,
                cancel: false,
                confirm: true,
                button: {
                    text: i18next.t('filesSlice.action.fetchFiles.swal.button'),
                    value: true,
                    visible: true,
                    className: 'btn btn-secondary',
                },
            }).then(() => {
                window.location.reload();
            });
            return thunkApi.rejectWithValue(error.message);
        }

        const { data, is_last_page } = await loadMoreResponse.json();

        if (is_last_page) {
            await thunkApi.dispatch(filesActions.changeNeedMore(!is_last_page));
        }

        return data.files;
    } catch (e) {
        return thunkApi.rejectWithValue(error.message ? error.message : error.toString());
    }
});
